import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './ProfessionalLayout.css';

const ProfessionalLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const navGroups = [
    {
      label: 'Main',
      items: [
        { path: '/professional/dashboard', label: 'Dashboard' },
        { path: '/professional/vett-id', label: 'My VETT ID' },
        { path: '/professional/records', label: 'My Records' },
        { path: '/professional/peer-reviews', label: 'Peer Reviews', disabled: true, phase: 'Phase 2' },
      ]
    },
    {
      label: 'Credential',
      items: [
        { path: '/professional/verification-requests', label: 'Verification Requests' },
      ]
    },
    {
      label: 'Account',
      items: [
        { path: '/professional/billing', label: 'Billing' },
        { path: '/professional/settings', label: 'Settings' },
        { path: '/professional/notifications', label: 'Notifications' },
      ]
    },
    {
      label: 'Support',
      items: [
        { path: '/professional/support', label: 'Support' },
      ]
    }
  ];

  return (
    <div className="pro-layout">
      {/* Top Navigation */}
      <nav className="pro-platform-nav">
        <Link className="pro-nav-logo" to="/">
          <div className="pro-nav-logo-mark">V</div>
          <span>ETT Pro</span>
        </Link>
        <div className="pro-nav-user">
          <span className="pro-nav-user-name">{user?.name || 'Professional'}</span>
          <button className="pro-nav-logout" onClick={handleLogout}>
            Log out
          </button>
        </div>
      </nav>

      {/* Dark Sidebar */}
      <aside className="pro-sidebar" data-testid="pro-sidebar">
        {navGroups.map((group, groupIndex) => (
          <div className="pro-sidebar-group" key={groupIndex}>
            <div className="pro-sidebar-label">{group.label}</div>
            {group.items.map((item, itemIndex) => (
              item.disabled ? (
                <span 
                  key={itemIndex}
                  className="pro-sidebar-link disabled"
                >
                  {item.label}
                  {item.phase && <span className="pro-sidebar-phase-pill">{item.phase}</span>}
                </span>
              ) : (
                <Link
                  key={itemIndex}
                  to={item.path}
                  className={`pro-sidebar-link ${isActive(item.path) ? 'active' : ''}`}
                  data-testid={`sidebar-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {item.label}
                </Link>
              )
            ))}
          </div>
        ))}
      </aside>

      {/* Main Content Area */}
      <div className="pro-shell">
        {children}
      </div>
    </div>
  );
};

export default ProfessionalLayout;
